module.exports = __webpack_public_path__ + "images/prime_shield_1ded8a4.png";